import { openModal } from '@components/modals';
import { execOnLoad } from '@general/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFitSize = (context) => {
  const baseClass = 'fit-size__container';
  const initializedClass = `${baseClass}--initialized`;
  const snippetContainer = context.classList.contains(baseClass)
    ? context
    : context.closest(`.${baseClass}`);
  if (
    !snippetContainer ||
    snippetContainer.classList.contains(initializedClass)
  )
    return;

  const modal = document.querySelector('.fit-size__modal');
  const modalContent = document.querySelector(
    '.fit-size__modal .modal__body-inner',
  );
  const opener = snippetContainer.querySelector('.fit-size__opener');
  const content = snippetContainer.querySelector('.fit-size__content');
  if (!modal || !modalContent || !opener || !content) return;

  opener.addEventListener('click', () => {
    modalContent.innerHTML = content.innerHTML;
    openModal(modal);
  });

  snippetContainer.classList.add(initializedClass);
};

execOnLoad(window.dAgency.initFitSize, '.fit-size__container');
